import api from "./api-service";

const baseUrl = "users-data";

export const getUserDataByToken = () => api().get(baseUrl + "/token");

export const updateUserDataLoggedUser = (userData) =>
  api().put(baseUrl + "/app", userData);
